// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TerceraNumeric } from "./TerceraNumeric.js";

export class QuickTableNumeric extends TerceraNumeric {
    constructor(data, callback, rect) {
        super();

        const editingInfo = data.cell.QuickTableEditingInfo;
        this.set({
            minValue: editingInfo.Min,
            maxValue: editingInfo.Max,
            step: editingInfo.Inc,
            decimalPrecision: editingInfo.DecimalPlaces
        });

        this.tag = data;
        this.callBack = callback;

        this.set('value', data.cell.value);
        this.setBounds(rect.X, rect.Y, rect.Width, rect.Height);
    }

    oncomplete() {
        super.oncomplete();
        this.setFocus();
    }

    processEnterKeyDown() {
        this.lostFocus();
    }

    lostFocus() {
        super.lostFocus();
        this.callBack(this.get('value'), this.tag);
    }

    validateValue(oldVal, newVal, min, max, prec) {
        var step = this.get('step');

        var result = TerceraNumeric.prototype.validateValue.call(this, oldVal, newVal, min, max, prec);

        //#55212
        if (result === 0)
        {
            var convNewVal = parseFloat(newVal);
            if (isNaN(convNewVal) || convNewVal === 0 || Math.abs(convNewVal) > step)
            return 0;

            return convNewVal > 0 ? step : -step;
        }

        //#53147
        if (Math.abs(result) < step)
            result = result > 0 ? step : -step;

        return result;
    }
}